module.exports = __webpack_public_path__ + "img/chat_white_24dp.b45dffaf.svg";